import { Sender } from 'xstate';
import asyncCallback from '../../../framework/logic/utils/asyncCallback';
import models from 'src/model';

export const watchPromotionsEvents = () =>
  asyncCallback(
    async (
      callback: Sender<
        | {
            type: 'PROMOTION_LIST_DISPLAYED';
            payload: { promotionLangCode: string };
          }
        | {
            type: 'PROMOTION_DETAILS_DISPLAYED';
            payload: {
              pageSlug: string;
              promotionLangCode: string;
            };
          }
        | {
            type: 'PROMOTIONS_GAME_OPEN_CLICK';
            payload: { presentationCode: string };
          }
      >
    ) => {
      return await models.promotionsWatcher({ callback });
    }
  );
